export default {
  records: ({ records }) => records,
  summary: ({ summary }) => summary,
};
